
export const APP_VERSION = '1.0.34';
export const APP_VERSION_DEV = '1.0.62';
export const BUILD_DATE = '15-08-2025 16:05:20';
export const BUILD_NUMBER = '150820251605';
